import { render, staticRenderFns } from "./goods.row.vue?vue&type=template&id=c742cc0c&scoped=true"
import script from "./goods.row.vue?vue&type=script&lang=js"
export * from "./goods.row.vue?vue&type=script&lang=js"
import style0 from "./goods.row.vue?vue&type=style&index=0&id=c742cc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c742cc0c",
  null
  
)

export default component.exports